import React, { useEffect } from 'react';
import { useBackgroundTheme } from '../hooks/useBackgroundTheme';

interface ThemedScreenProps {
  children: React.ReactNode;
  className?: string;
}

const ThemedScreen: React.FC<ThemedScreenProps> = ({ children, className = '' }) => {
  const { selectedThemeData } = useBackgroundTheme();

  useEffect(() => {
    const savedSize = localStorage.getItem('calmi_text_size') || 'normal';
    const sizeMap: Record<string, string> = {
      normal: '100%',
      large: '112%',
      xlarge: '125%'
    };
    document.documentElement.style.fontSize = sizeMap[savedSize] || '100%';
  }, []);

  const backgroundStyle: React.CSSProperties = {
    backgroundImage: `${selectedThemeData.pattern}, ${selectedThemeData.gradient}`,
    backgroundSize: `${selectedThemeData.patternSize}, 100% 100%`,
    backgroundPosition: '0 0, 0 0',
    backgroundAttachment: 'fixed, fixed',
    minHeight: '100vh'
  };

  return (
    <div className={`${selectedThemeData.textColor} ${selectedThemeData.themeClass} ${className}`} style={backgroundStyle}>
      {children}
    </div>
  );
};

export default ThemedScreen;
